import { handleActions } from 'redux-actions';
import { push } from "react-router-redux";
import { initialize as initializeForm, reset } from "redux-form";
import { api } from "api";
import { NotificationManager, __esModule} from "react-notifications";
import { getMunicipios } from '../../../utility/constants';
import _ from 'lodash';
import moment from 'moment';

import { MESES } from '../../../utility/constants';


let url = 'reportes' ;
let form = '';
let dirGrid = '/';


export const constants ={
    LOADER: 'REPORTE_ventas_LOADER',
    RESUMEN: 'REPORTE_ventas_RESUMEN',
    TOTALES: 'TOTALES_ventas_RESUMEN',
    DATA: 'REPORTE_ventas_DATA',
    PAGE: 'REPORTE_ventas_PAGE',
    SET_CLIENTE: 'SET_CLIENTE_VENTAS',
    SET_VENDEDOR: 'SET_VENDEDOR_VENTAS',
    SET_TIPO_PRODUCTO: 'SET_TIPO_PRODUCTO_VENTAS',
    SET_FECHA_I: 'SET_FECHA_I_VENTAS',
    SET_FECHA_F: 'SET_FECHA_F_VENTAS',
    SET_EMPRESAS:'VENTAS_SET_EMPRESAS',
    SET_SEARCH_EMPRESA: 'VENTAS_SET_SEARCH_EMPRESA',
    SET_REGIONES: 'SET_REGIONES',
    SET_MUNICIPIOS: 'SET_MUNICIPIOS',
    SET_REGION: 'SET_REGION',
    SET_MUNICIPIO: 'SET_MUNICIPIO',
    SET_DEPARTAMENTO: 'SET_DEPARTAMENTO',
}

// PURE ACTIONS

const setLoader = loader =>({
    type:constants.LOADER,
    loader
});

const setData = (type, data) => ({
    type,
    data
});

const setPage = page => ({
    type: constants.PAGE,
    page,
});

const setFechaI = fecha_inicio =>({
    type:constants.SET_FECHA_I,
    fecha_inicio
});

const setFechaF = fecha_fin =>({
    type:constants.SET_FECHA_F,
    fecha_fin
});

const setDataSelect = (type, data) =>({
    type,
    data
});

// ACTIONS

const getTotales = () => (dispatch, getStore) => {

    dispatch(listarCobros());
    return ;


    const resource = getStore().reporteVentas;
    const params = { };
    if (resource.fecha_inicio)
        params.fecha_inicio = resource.fecha_inicio.format("YYYY-MM-DD");
    if (resource.fecha_fin)
        params.fecha_fin = resource.fecha_fin.format("YYYY-MM-DD");
    if (resource.vendedor)
        params.vendedor = resource.vendedor.id;
    if (resource.cliente)
        params.cliente = resource.cliente.id;
    if (resource.tipo_producto)
        params.tipo_producto = resource.tipo_producto.id;
    if (resource.empresa){
        params.empresa = resource.empresa.value
    }
    const me = getStore().login.me
    const visualizar_mis_datos = me.permisos.visualizar_mis_datos
    if(visualizar_mis_datos == true){
        params.visualizar_mis_datos = true
        params.id_user = me.id
    }
    dispatch(setLoader(true));
    api.get(`${url}/totales_metas`, params).then((response) => {
        console.log("Response ", response);
        let total_ventas = 0;
        let total_metas = 0;
        const array = [['Mes', 'Ventas', 'Metas']];
        const ventas = _.cloneDeep(response.results);
        const metas = _.cloneDeep(response.metas);

        for (const index in ventas){
            const fecha = moment(ventas[index].fecha);
            const item = _.find(MESES, { value: fecha.month()+1 });
            total_ventas += ventas[index].total;
            total_metas += metas[index].total;
            array.push([item.label, ventas[index].total, metas[index].total])
        }

        dispatch(setData(constants.RESUMEN, response));
        dispatch(setData(constants.TOTALES, {
            ventas: total_ventas,
            metas: total_metas,
            grafica: array,
        }));
        dispatch(listarCobros());
    }).catch(() => {
    }).finally(() => {
        // dispatch(setLoader(false));
    });
};

const listarCobros = (page = 1) => (dispatch, getStore) => {
    const resource = getStore().reporteVentas;
    const params = { page };
    const resumen_subtotal = []
    if (resource.fecha_inicio)
        params.fecha_inicio = resource.fecha_inicio.format("YYYY-MM-DD");
    if (resource.fecha_fin)
        params.fecha_fin = resource.fecha_fin.format("YYYY-MM-DD");
    if (resource.vendedor)
        params.vendedor = resource.vendedor.id;
    if (resource.cliente)
        params.cliente = resource.cliente.id;
    if (resource.tipo_producto)
        params.tipo_producto = resource.tipo_producto.id;
    if (resource.empresa){
        params.empresa = resource.empresa.value
    }
    if (resource.region){
        params.regionId = resource.region.id;
    }
    if (resource.departamento){
        params.departamento = resource.departamento;
    }
    if (resource.municipio){
        params.municipio = resource.municipio;
    }

    const me = getStore().login.me
    const visualizar_mis_datos = me.permisos.visualizar_mis_datos
    if(visualizar_mis_datos == true){
        params.visualizar_mis_datos = true
        params.id_user = me.id
    }
    dispatch(setLoader(true));
    api.get(`${url}/reporteventas`, params).then((response) => {
        const resumen = resource.resumen;
        const results = _.cloneDeep(response.results);
        const totales = _.cloneDeep(response.totales);
        const metas = _.cloneDeep(response.totales_metas);
        const ventas = _.cloneDeep(response.totales);

        // Calcular Subtotales
        if(results.length > 0){
            results[0].meses.forEach(mes =>{
                resumen_subtotal.push({total: 0})
            })
            results.forEach(cliente =>{
                cliente.meses.forEach((mes, index) =>{
                    resumen_subtotal[index].total += mes.total  
                })
            })
        }

        // Set data para grafico de Metas
        let grafica_metas = {
            ventas: 0,
            metas: 0,
            grafica: [['Mes', 'Ventas', 'Metas']],
        }
        for (let i = 0; i < ventas.length; i++) {
            grafica_metas.ventas += parseFloat(ventas[i].total);
            grafica_metas.metas += parseFloat(metas[i].total);
            const mes_ = _.find(MESES, { value: ventas[i].mes });
            grafica_metas.grafica.push([mes_.label, ventas[i].total, metas[i].total])
        }


        results.unshift({id: 0, cliente_nombre: "TOTAL GENERAL", meses: totales});
        results.push({id: 0, cliente_nombre: "SUBTOTAL", meses: resumen_subtotal});
        results.push({id: 0, cliente_nombre: "METAS", meses: response.totales_metas});

        response.results = results;
        dispatch(setData(constants.RESUMEN, totales));
        dispatch(setData(constants.DATA, response));
        dispatch(setData(constants.TOTALES, grafica_metas));
        dispatch(setPage(page));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const setMunicipios = (departament) => (dispatch) =>{
    let municipios = getMunicipios(departament)
    dispatch({type: constants.SET_MUNICIPIOS, data:municipios})
};

const selectRegiones = () => (dispatch) =>{
    dispatch(setLoader(true));
    api.get('region/selectregiones').then((res)=>{
        dispatch({type: constants.SET_REGIONES, data:res})
    }).catch(()=>{
    }).finally(()=>{
        dispatch(setLoader(false))
    })
};

const setRegion = (region) => (dispatch) =>{
    dispatch({type: constants.SET_REGION, region:region});
    dispatch(getTotales());
};
const setMunicipio = (municipio) => (dispatch) =>{
    dispatch({type: constants.SET_MUNICIPIO, municipio:municipio});
    dispatch(getTotales());
};
const setDepartamento = (departamento) => (dispatch) =>{
    dispatch({type: constants.SET_DEPARTAMENTO, departamento:departamento});
    dispatch(getTotales());
};


const descargaArchivoVentaPorMesEP = () => (dispatch, getStore) => {
    dispatch(setLoader(true));
    const resource = getStore().reporteVentas;
    const params = {};

    if (resource.fecha_inicio)
        params.fecha_inicio = resource.fecha_inicio.format("YYYY-MM-DD");
    if (resource.fecha_fin)
        params.fecha_fin = resource.fecha_fin.format("YYYY-MM-DD");
    if (resource.vendedor)
        params.vendedor = resource.vendedor.id;
    if (resource.cliente)
        params.cliente = resource.cliente.id;
    if (resource.tipo_producto)
        params.tipo_producto = resource.tipo_producto.id;
    if (resource.empresa){
        params.empresa = resource.empresa.value
    }
    if (resource.region){
        params.regionId = resource.region.id;
    }
    if (resource.departamento){
        params.departamento = resource.departamento;
    }
    if (resource.municipio){
        params.municipio = resource.municipio;
    }
    if (resource.cliente_ov) {
        params["id_cliente"] = resource.cliente_ov.id;
    }

    api.get(`${url}/descargar_reporte_ventas_por_mes`, params).then((response) => {
        NotificationManager.success(response.detail, 'Éxito', 5000);
        setTimeout(() => {
            dispatch(cicloVerificacion(response.id_archivo));
        }, 500);
    }).catch(() => {
        NotificationManager.error('Error en la Descarga del Reporte', 'Error', 5000);
        dispatch(setLoader(false));
    }).finally(() => {
    });
};

const cicloVerificacion = (id_archivo) => (dispatch, getStore) => {
    dispatch(setLoader(true));
    setTimeout(function () {
        dispatch(descarga_estadoEP(id_archivo));
    }, 5000)
}

const descarga_estadoEP = (id_archivo) => (dispatch, getStore) => {
    let FALLO = 0;
    let FINALIZADO = 1;
    let EN_PROCESO = 2;

    let params = { id_archivo }
    api.get(`${url}/descargar_estado`, params).then((response) => {
        if (response.estado == EN_PROCESO){
            dispatch(cicloVerificacion(id_archivo));
        }
        else if (response.estado == FINALIZADO){
            dispatch(setLoader(false));
            if (response.id) {
                // window.open(response.archivo);
                const link = document.createElement('a');
                const fileName = response.archivo.split('/').pop();

                link.href = response.archivo;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                link.remove();
            }
        }
        else if (response.estado == FALLO){
            dispatch(setLoader(false));
            NotificationManager.error(response.motivo, 'Error', 5000);
        }
    }).catch(() => {
        NotificationManager.error('Error en la Descarga del Reporte', 'Error', 5000);
        dispatch(setLoader(false));
    }).finally(() => {
    });
};

const changeCliente = (value) => (dispatch) => {
    dispatch(setData(constants.SET_CLIENTE, value));
    dispatch(getTotales());
};

const changeVendedor = (value) => (dispatch) => {
    dispatch(setData(constants.SET_VENDEDOR, value));
    dispatch(getTotales());
};

const changeTproducto = (value) => (dispatch) => {
    dispatch(setData(constants.SET_TIPO_PRODUCTO, value));
    dispatch(getTotales());
};

const changeFechaInicio = (value) => (dispatch) => {
    dispatch(setFechaI(value));
    dispatch(getTotales());
};

const changeFechaFin = (value) => (dispatch) => {
    dispatch(setFechaF(value));
    dispatch(getTotales());
};

const changeEmpresa = empresa => dispatch => {
    dispatch({type:constants.SET_SEARCH_EMPRESA, empresa});
    dispatch(getTotales());
}
const selectEmpresas = () => (dispatch) =>{
    dispatch(setLoader(true));
    api.get('empresa/selectempresasE').then((res)=>{
        dispatch(setDataSelect(constants.SET_EMPRESAS, res))
    }).catch(()=>{
    }).finally(()=>{
        dispatch(setLoader(false))
    })
}

export const actions = {
    getTotales,
    listarCobros,
    setMunicipios,
    selectRegiones,
    setRegion,
    setMunicipio,
    setDepartamento,
    descargaArchivoVentaPorMesEP,
    changeCliente,
    changeVendedor,
    changeFechaInicio,
    changeFechaFin,
    changeTproducto,
    changeEmpresa,
    selectEmpresas
}


export const reducers = {
    [constants.LOADER]:(state, { loader }) =>{
        return{
            ...state,
            loader,
        };
    },
    [constants.RESUMEN]:(state, { data }) => {
        return{
            ...state,
            resumen: data
        }
    },
    [constants.TOTALES]:(state, { data }) => {
        return{
            ...state,
            totales: data
        }
    },
    [constants.DATA]:(state, { data }) => {
        return{
            ...state,
            data: data
        }
    },
    [constants.PAGE]: (state, { page }) => {
        return {
            ...state,
            page,
        };
    },
    [constants.SET_CLIENTE]: (state, { data }) => {
        return {
            ...state,
            cliente: data
        };
    },
    [constants.SET_REGIONES]:(state,{ data })=>{
        return{
            ...state,
            regiones: data,
        }
    },
    [constants.SET_MUNICIPIOS]:(state,{ data })=>{
        return{
            ...state,
            municipios: data,
        }
    },
    [constants.SET_REGION]:(state,{ region })=>{
        return{
            ...state,
            region: region,
        }
    },
    [constants.SET_MUNICIPIO]:(state,{ municipio })=>{
        return{
            ...state,
            municipio: municipio,
        }
    },
    [constants.SET_DEPARTAMENTO]:(state,{ departamento })=>{
        return{
            ...state,
            departamento: departamento,
        }
    },
    [constants.SET_VENDEDOR]: (state, { data }) => {
        return {
            ...state,
            vendedor: data
        };
    },
    [constants.SET_FECHA_I]: (state, { fecha_inicio }) => {
        return {
            ...state,
            fecha_inicio
        };
    },
    [constants.SET_FECHA_F]: (state, { fecha_fin }) => {
        return {
            ...state,
            fecha_fin
        };
    },
    [constants.SET_TIPO_PRODUCTO]: (state, { data }) => {
        return {
            ...state,
            tipo_producto: data
        };
    },
    [constants.SET_EMPRESAS]:(state,{ data })=>{
        return{
            ...state,
            empresas: data.empresa,
        }
    },
    [constants.SET_SEARCH_EMPRESA]: (state, {empresa}) => {
        return {
            ...state,
            empresa
        }
    },
}

export const initialState = {
    loader:false,
    resumen: [],
    totales: {
        ventas: 0,
        metas: 0,
        grafica: [['Mes', 'Ventas', 'Metas'], ['Sin data', 0, 0]],
    },
    data: {
        results: [],
        count: 0,
    },
    page: 1,
    cliente: null,
    vendedor: null,
    tipo_producto: null,
    fecha_inicio: moment(`${moment().year()}-1-1`),
    fecha_fin: moment(),
    regiones:[],
    municipios:[],
    region: null,
    municipio: null,
    departamento: null,
    empresa: null,
    empresas: []
}

export default handleActions(reducers, initialState);
